import { render, staticRenderFns } from "./Printer.vue?vue&type=template&id=f5db01c8&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Printer.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Printer.vue
// module id = 1733
// module chunks = 1